import React, { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import axios from "axios";
import AuthBlocker from "./AuthBlocker";
import apiUrls from "../config.js";
import manual from  "../descargas/Manual.pdf"
import { useAccessToken } from '../AccessTokenProvider';
import LoggerComponent from '../LoggerComponent.js';
import mensajesLog from "../mensajesLog.js";
const Menu = () => {
  const { accessToken } = useAccessToken();
   
  const location = useLocation();
  const [, updateState] = useState();
  const forceUpdate = useCallback(() => updateState({}), []);
  const [token, setToken] = useState("");
  const [perfil, getPerfil] = useState(3);
  const [tokenIsValid, setTokenIsValid] = useState(false);
  const [msg, setmsg] = useState("");
  const [jwt,setjwt]=useState(null);
  const loggerInstance = LoggerComponent();
  useEffect(() => {
    async function getToken(token) {
      
      try {
        const f = {
          jwt: token
        };
        const config = {
          headers: {
            "Content-Type": "application/json"
          }
        };

        await axios
          .post(apiUrls.desencriptar, f, config)
          .then(async (response) => {
            var decodedToken = jwtDecode(response.data.jwt, { complete: true });
            setjwt(jwt);
            const ahora = Date.now() / 1000;
            if (decodedToken.exp < ahora) {
              throw new Error("Token no valido");
            }
            getPerfiles(response.data.jwt, token);
          })
          .catch((error) => {
            console.log(error);
            setmsg("Usted no tiene acceso a este sistema");
            setTokenIsValid(false);
          });
      } catch (error) {
        console.log(error);
        setmsg("Usted no tiene acceso a este sistema");
        setTokenIsValid(false);
      }
    }

    function getPerfiles(token_, token) {
      let config2 = {
        method: "get",
        maxBodyLength: Infinity,
        url: apiUrls.permisos,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token_}`
        }
      };
      axios
        .request(config2)
        .then((response) => {
          const permiso = response.data.permisos;
          if (permiso > 0) {
            if (permiso === 1) {
              getPerfil(permiso);
              const data = {
                level: 'info',
                mensaje: jwt,
                accion: mensajesLog.ConsultarGEOBIN
              };
              loggerInstance.sendDataToApi(data);
              window.location.href = apiUrls.geobintWeb+`/#/?access_token=${token}`;
            } else {
              getPerfil(permiso);
              setTokenIsValid(true);
            }
          } else {
            console.log("error de perfil");
            setmsg("Usted no tiene acceso a este sistema.");
            setTokenIsValid(false);
            const data = {
              level: 'info',
              mensaje: jwt,
              accion: mensajesLog.ErrorAccesoSNII
            };
            loggerInstance.sendDataToApi(data);
          }
        })
        .catch((error) => {
          setmsg("Usted no tiene acceso a este sistema");
          setTokenIsValid(false);
          console.error("Error de servidor:", error.response);
          console.error("Error detallado:", error.message);
          console.error("Stack trace:", error.stack);
          const data = {
            level: 'info',
            mensaje: jwt,
            accion: mensajesLog.ErrorAccesoSNII
          };
          loggerInstance.sendDataToApi(data);
        });
    }

    const parametros = new URLSearchParams(location.search);
    if (accessToken) {
      setToken(accessToken);
      getToken(accessToken);
    } 
 
  }, [forceUpdate, location.search,accessToken]);

  // menu
  const menuItems = {
    1: [
      {
        title: "Consulta de información  Georreferenciada",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: apiUrls.geobintWeb+`/#/?access_token=${token}`
      }
    ],
    2: [
      {
        title: "Cargar Archivos",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `/?access_token=${token}`
      },
      {
        title: "Estado de Cargas",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `ListaDeArchivos?access_token=${token}`
      },
      {
        title: "Descarga de Plantillas",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `ListaFormatos?access_token=${token}`
      }
    ],
    3: [
      {
        title: "Cargar Archivos",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `/?access_token=${token}`
      },
      {
        title: "Estado de Cargas",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `ListaDeArchivos?access_token=${token}`
      },
      {
        title: "Descarga de Plantillas",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: `ListaFormatos?access_token=${token}`
      },
      {
        title: "Consulta de información  Georreferenciada",
        icon: "fas fa-solid fa-caret-right fs-5",
        link: apiUrls.geobintWeb+`/#/?access_token=${token}`
      }
    ]
  };

  const filteredMenu = menuItems[perfil];
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = manual;
    a.download = "Manual.pdf"; // Establece el nombre del archivo para la descarga
    a.click();
  };
  return (
    <>
    <AuthBlocker tokenIsValid={tokenIsValid} msg={msg} />
    <nav className="navbar navbar-dark align-items-start sidebar sidebar-dark accordion bg-gradient-primary p-0" data-bs-toggle="tooltip" data-bss-tooltip="" style={{ background: '#77bd43',border:'solid 1px green;' }}>
      <div className="container-fluid d-flex flex-column p-0">
        <a className="navbar-brand d-flex justify-content-center align-items-center sidebar-brand m-0" href="#">
          <div className="sidebar-brand-text mx-3"></div>
        </a>
        <hr className="sidebar-divider my-0" />
        <ul className="navbar-nav text-light" id="accordionSidebar">
          {filteredMenu.map((item, index) => (
            <li className="nav-item" key={index}>
              <a
                className="nav-link"
                data-bss-hover-animate="pulse"
                href={item.link}
              >
                <i className={item.icon}></i>
                <span>{item.title}</span>
              </a>
            </li>
          ))}
          <li className="nav-item">
            <a
              className="nav-link"
              data-bss-hover-animate="pulse"
              onClick={handleDownload}
              href="#"
            >
              <i className="fas fa-solid fa-caret-right fs-5"></i>
              <span>Descarga Manual SNII</span>
            </a>
          </li>
          <li className="nav-item">
            <a
              className="nav-link"
              data-bss-hover-animate="pulse"
              href="#"
              onClick={() => window.close()}
            >
              <i className="fas fa-solid fa-caret-right fs-5"></i>
              <span>Cerrar sesión</span>
            </a>
          </li>
        </ul>
        <div className="text-center d-none d-md-inline">
          <button className="btn rounded-circle border-0" data-bss-hover-animate="jello" id="sidebarToggle" type="button"></button>
        </div>
      </div>
    </nav>
  </>
  );
};

export default Menu;
